import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectAdminEvent } from '../../../../../data-services/stores/selectors/admin.selectors';
import { CommonModule } from '@angular/common';
import { AdminBoilerplateComponent } from "../../../../../core/admin-boilerplate/feature/admin-boilerplate.component";
import { HeadlineComponent } from "../../../../../events/headline/feature/headline.component";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { TabsModule } from 'primeng/tabs';
import { adminActions } from '../../../../../data-services/stores/actions/admin.actions';
import { CateringDatesPipe } from "../../../../../data-services/pipes/catering-dates.pipe";
import { EventDatesPipe } from "../../../../../data-services/pipes/event-dates.pipe";

@Component({
  selector: 'app-admin-catering',
  imports: [CommonModule, AdminBoilerplateComponent, HeadlineComponent, FormsModule, ReactiveFormsModule, EditorModule, TabsModule, CateringDatesPipe, EventDatesPipe],
  templateUrl: '../ui/catering.component.html',
  styleUrl: '../ui/catering.component.css',
})
export class AdminEventCateringComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  lrpEvent$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"]))
  activeTab: string = 'cateringDetails'
  cateringForm = new FormGroup({
    catererName: new FormControl<string>('',[Validators.required, Validators.minLength(3)]),
    catererContact: new FormControl<string>(''),
    display: new FormControl<Boolean>(false),
    notes: new FormControl<string>('')
  })

  ngOnInit(): void {
    this._store.dispatch(adminActions.getEvent({ eventRef:this._route.snapshot.params["id"] }))
  }

  parseDate(input: Date): Date{
    return new Date(input)
  }
}
